import {
  FormControl,
  FormHelperText,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Switch,
  TextField,
  Box,
  Paper,
  Typography,
} from "@mui/material";
import ISourceMapSaveDataBody from "../../../../../../shared/contracts/ISourceMapSaveDataBody";
import { useContext } from "react";
import { CreateSourceMapContext } from "../../../../../../shared/context/create-sourcemap/create-sourcemap-context";
import FormControlLabel from "@mui/material/FormControlLabel";
import * as React from "react";
import { useState } from "react";

interface IProps {}

function SourceMapDetailsComponent({}: IProps) {
  const { createSourceMapForm, dispatch } = useContext(CreateSourceMapContext)!;

  return (
    <Paper
      elevation={2}
      sx={{
        padding: 4,
        margin: "auto",
        maxWidth: 800,
        flexGrow: 1,
        backgroundColor: "#f7f7f7",
      }}
    >
      <Typography variant="h6" gutterBottom align="center">
        Source Map Configuration
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            fullWidth
            id="sourceMap-name"
            label="Source Map Name"
            variant="outlined"
            value={createSourceMapForm.sourceMapLabel}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: "UPDATE",
                payload: { sourceMapLabel: event.target.value },
              });
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            fullWidth
            id="sourceMap-description"
            label="Source Map Description"
            variant="outlined"
            value={createSourceMapForm.sourceMapDesc}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: "UPDATE",
                payload: { sourceMapDesc: event.target.value },
              });
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel>Source Map Type</InputLabel>
            <Select
              value={createSourceMapForm.sourceMapType}
              label="Source Map Type"
              onChange={(e: SelectChangeEvent) => {
                dispatch({
                  type: "UPDATE",
                  payload: { sourceMapType: e.target.value },
                });
              }}
            >
              <MenuItem value={"Charge Back"}>
                <em>Charge Back</em>
              </MenuItem>
              <MenuItem value={"Contract Pricing"}>
                <em>Contract Pricing</em>
              </MenuItem>
              <MenuItem value={"Product"}>
                <em>Product</em>
              </MenuItem>
              <MenuItem value={"Contract"}>
                <em>Contract</em>
              </MenuItem>
              <MenuItem value={"RefreshCPIUData"}>
                <em>Refresh CPIU Data</em>
              </MenuItem>
              <MenuItem value={"Customer"}>
                <em>Customer</em>
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={createSourceMapForm.active}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  dispatch({
                    type: "UPDATE",
                    payload: { active: e.target.checked },
                  });
                }}
              />
            }
            label="Active"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel>CSV Delimiter</InputLabel>
            <Select
              value={createSourceMapForm.csvDelimiter}
              label="CSV Delimiter"
              onChange={(e: SelectChangeEvent) => {
                dispatch({
                  type: "UPDATE",
                  payload: { csvDelimiter: e.target.value },
                });
              }}
            >
              <MenuItem value={","}>
                <em>Comma (,)</em>
              </MenuItem>
              <MenuItem value={" "}>
                <em>Tab ( )</em>
              </MenuItem>
              <MenuItem value={";"}>
                <em>Semicolon (;)</em>
              </MenuItem>
              <MenuItem value={"|"}>
                <em>Pipe (|)</em>
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12}>
          <TextField
            size="small"
            fullWidth
            id="emailTo"
            label="Email To"
            placeholder="Email addresses separated by ,"
            value={createSourceMapForm.emailTo}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: "UPDATE",
                payload: { emailTo: event.target.value },
              });
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            fullWidth
            id="emailCc"
            label="Email CC"
            placeholder="CC Email addresses"
            value={createSourceMapForm.emailCc}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: "UPDATE",
                payload: { emailCc: event.target.value },
              });
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            size="small"
            fullWidth
            id="emailBcc"
            label="Email BCC"
            placeholder="BCC Email addresses"
            value={createSourceMapForm.emailBcc}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              dispatch({
                type: "UPDATE",
                payload: { emailBcc: event.target.value },
              });
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default SourceMapDetailsComponent;
